import i18next from 'i18next';
import metadata from './components/metadata.json';
//import { userDataStore } from './store/configureStore';

i18next
    .init({
        fallbackLng: "en",
        interpolation: {
            // React already does escaping
            escapeValue: false,
        },
        lng: "en", // 'en' | 'es'
        resources: {
            en: {
                translation: {
                    app: {
                        meetingInfo: "Meeting Information",
                        title: "Title",
                        time: "Time",
                        JoinZoomMeeting: "Join Zoom Meeting",
                        copyAll: "Copy All",
                        participants: "Participants",
                        selectAll: "Select All",
                        search: "Search",
                        scheduleMeeting: "Schedule Meetings",
                        meetingTitle: "Meeting Title",
                        date: "Date",
                        duration: "Duration",
                        timeZone: "Time Zone",
                        attendees: "Attendees",
                        invite: "Invite",
                        save: "Save",
                        ok: "Ok",
                        join: "Join",
                        logout: "Logout",
                        settings: "Settings",
                        zoomLogout: "Successfully logged out",
                        zoomMeetingLoggedOut: "Zoom Meeting Logged Out",
                        zoomMeetEnd: "Zoom Meeting Ended",
                        zoomMeetEnded: "Zoom Meeting successfully ended",
                        noMeetStart: "Meeting has not started!",
                        invitationHasBeenSentSuccessfully: "Invitation has been sent successfully",
                        youHaveBeenInvitedToJoin: "You have been invited to join",
                        useThisLinkToJoinTheMeeting: "Use this link to join the meeting",
                        makeSureToAllowPopups: "Make sure to allow popups",
                        theMeetingSchedulehasbeensetSuccessfully: "The Meeting Schedule has been set Successfully",
                        youNeedToChooseAtLeastOneInvitee: "You need to choose at least one invitee",
                        zoomAuthSuccess: metadata.appName + " Zoom application identity successfully authenticated",
                        limitAlertMessage: " You have exceeded the daily limits (100) of allowed Meeting Creation/Update API requests for this specific user. You can resume these requests at 00:00:00 GMT.",
                        success: 'Success',
                        error:'Error',
                    }
                }
            },
            es: {
                translation: {
                    app: {
                        meetingInfo: "Información de la reunión",
                        title: "Título",
                        time: "Hora",
                        JoinZoomMeeting: "Unirse a la reunión de Zoom",
                        copyAll: "Copiar todo",
                        participants: "Participantes",
                        selectAll: "Seleccionar todo",
                        search: "Buscar",
                        scheduleMeeting: "Programar reunión",
                        meetingTitle: "Título de la reunión",
                        date: "Fecha",
                        duration: "Duración",
                        timeZone: "Zona horaria",
                        attendees: "Asistentes",
                        invite: "Invitar",
                        save: "Guardar",
                        ok: "Aceptar",
                        join: "Unirse",
                        logout: "Cerrar sesión",
                        settings: "Configuración",
                        zoomLogout: "Has cerrado sesión correctamente",
                        zoomMeetingLoggedOut: "Se cerró la sesión de la reunión de Zoom correctamente",
                        zoomMeetEnd: "La reunión de Zoom ha terminado",
                        zoomMeetEnded: "La reunión de Zoom ha finalizado correctamente",
                        noMeetStart: "¡La reunión no ha comenzado!",
                        invitationHasBeenSentSuccessfully: "La invitación se ha enviado correctamente",
                        youHaveBeenInvitedToJoin: "Has sido invitado a unirte",
                        useThisLinkToJoinTheMeeting: "Utiliza este enlace para unirte a la reunión",
                        makeSureToAllowPopups: "Asegúrate de permitir las ventanas emergentes",
                        theMeetingSchedulehasbeensetSuccessfully: "Se ha programado la reunión correctamente",
                        youNeedToChooseAtLeastOneInvitee: "Debes elegir al menos un invitado",
                        zoomAuthSuccess: "La identidad de la aplicación " + metadata.appName + " Zoom se ha verificado correctamente",
                        limitAlertMessage: "Has superado los límites diarios permitidos (100) para las solicitudes de creación/actualización de reuniones para este usuario específico. Puedes continuar con estas solicitudes a partir de las GMT 00:00:00.",
                        success: 'Éxito',
                        error: 'Error',


                    }
                }
            },
            ar: {
                translation: {
                    app: {
                        meetingInfo: "معلومات الاجتماع",
                        title: "العنوان",
                        time: "الوقت",
                        JoinZoomMeeting: "الانضمام إلى اجتماع Zoom",
                        copyAll: "نسخ الكل",
                        participants: "المشاركين",
                        selectAll: "تحديد الكل",
                        search: "بحث",
                        scheduleMeeting: "جدولة الاجتماعات",
                        meetingTitle: "عنوان الاجتماع",
                        date: "التاريخ",
                        duration: "المدة",
                        timeZone: "المنطقة الزمنية",
                        attendees: "المشاركون",
                        invite: "دعوة",
                        save: "حفظ",
                        ok: "موافق",
                        join: "الانضمام",
                        logout: "تسجيل الخروج",
                        settings: "الإعدادات",
                        zoomLogout: "لقد قمت بتسجيل الخروج بنجاح",
                        zoomMeetingLoggedOut: "تم تسجيل خروج جلسة Zoom بنجاح",
                        zoomMeetEnd: "انتهت جلسة Zoom",
                        zoomMeetEnded: "تم إنهاء جلسة Zoom بنجاح",
                        noMeetStart: "لم يبدأ الاجتماع بعد!",
                        invitationHasBeenSentSuccessfully: "تم إرسال الدعوة بنجاح",
                        youHaveBeenInvitedToJoin: "تمت دعوتك للانضمام",
                        useThisLinkToJoinTheMeeting: "استخدم هذا الرابط للانضمام إلى الاجتماع",
                        makeSureToAllowPopups: "تأكد من السماح بالنوافذ المنبثقة",
                        theMeetingSchedulehasbeensetSuccessfully: "تم تحديد جدول الاجتماع بنجاح",
                        youNeedToChooseAtLeastOneInvitee: "يجب عليك اختيار مدعو واحد على الأقل",
                        zoomAuthSuccess: "تم التحقق بنجاح من هوية تطبيق " + metadata.appName + " Zoom",
                        limitAlertMessage: "لقد تجاوزت حدود الطلبات اليومية المسموح بها (100) لإنشاء/تحديث اجتماعات لهذا المستخدم المحدد. يمكنك الاستمرار في هذه الطلبات في GMT 00:00:00.",
                        success: '',
                        error: '',

                    }
                }
            },
            fr: {
                translation: {
                    app: {
                        meetingInfo: "Informations sur la réunion",
                        title: "Titre",
                        time: "Heure",
                        JoinZoomMeeting: "Rejoindre la réunion Zoom",
                        copyAll: "Copier tout",
                        participants: "Participants",
                        selectAll: "Sélectionner tout",
                        search: "Rechercher",
                        scheduleMeeting: "Planifier une réunion",
                        meetingTitle: "Titre de la réunion",
                        date: "Date",
                        duration: "Durée",
                        timeZone: "Fuseau horaire",
                        attendees: "Participants",
                        invite: "Inviter",
                        save: "Enregistrer",
                        ok: "Ok",
                        join: "Rejoindre",
                        logout: "Déconnexion",
                        settings: "Paramètres",
                        zoomLogout: "Vous avez été déconnecté avec succès",
                        zoomMeetingLoggedOut: "La session Zoom a été déconnectée avec succès",
                        zoomMeetEnd: "La réunion Zoom est terminée",
                        zoomMeetEnded: "La réunion Zoom s'est terminée avec succès",
                        noMeetStart: "La réunion n'a pas encore commencé !",
                        invitationHasBeenSentSuccessfully: "L'invitation a été envoyée avec succès",
                        youHaveBeenInvitedToJoin: "Vous avez été invité à rejoindre",
                        useThisLinkToJoinTheMeeting: "Utilisez ce lien pour rejoindre la réunion",
                        makeSureToAllowPopups: "Assurez-vous d'autoriser les pop-ups",
                        theMeetingSchedulehasbeensetSuccessfully: "Le calendrier de la réunion a été défini avec succès",
                        youNeedToChooseAtLeastOneInvitee: "Vous devez choisir au moins un invité",
                        zoomAuthSuccess: "L'identité de l'application " + metadata.appName + " Zoom a été vérifiée avec succès",
                        limitAlertMessage: "Vous avez dépassé les limites quotidiennes autorisées (100) pour les demandes de création/mise à jour de réunions pour cet utilisateur spécifique. Vous pouvez continuer avec ces demandes à partir de GMT 00:00:00.",
                        success: 'Réussite',
                        error: 'Erreur',

                    }
                }
            },
            ru: {
                translation: {
                    app: {
                        meetingInfo: "Информация о встрече",
                        title: "Заголовок",
                        time: "Время",
                        JoinZoomMeeting: "Присоединиться к собранию Zoom",
                        copyAll: "Копировать все",
                        participants: "Участники",
                        selectAll: "Выбрать все",
                        search: "Поиск",
                        scheduleMeeting: "Запланировать встречу",
                        meetingTitle: "Заголовок встречи",
                        date: "Дата",
                        duration: "Продолжительность",
                        timeZone: "Часовой пояс",
                        attendees: "Участники",
                        invite: "Пригласить",
                        save: "Сохранить",
                        ok: "Ок",
                        join: "Присоединиться",
                        logout: "Выйти",
                        settings: "Настройки",
                        zoomLogout: "Вы успешно вышли",
                        zoomMeetingLoggedOut: "Сеанс Zoom успешно завершен",
                        zoomMeetEnd: "Встреча Zoom завершена",
                        zoomMeetEnded: "Встреча Zoom успешно завершена",
                        noMeetStart: "Встреча еще не началась!",
                        invitationHasBeenSentSuccessfully: "Приглашение успешно отправлено",
                        youHaveBeenInvitedToJoin: "Вас пригласили присоединиться",
                        useThisLinkToJoinTheMeeting: "Используйте эту ссылку для присоединения к встрече",
                        makeSureToAllowPopups: "Убедитесь, что разрешены всплывающие окна",
                        theMeetingSchedulehasbeensetSuccessfully: "График встречи успешно установлен",
                        youNeedToChooseAtLeastOneInvitee: "Вы должны выбрать хотя бы одного приглашенного",
                        zoomAuthSuccess: "Идентификация приложения " + metadata.appName + " Zoom успешно подтверждена",
                        limitAlertMessage: "Вы превысили ежедневные лимиты разрешенных запросов (100) на создание/обновление встреч для этого конкретного пользователя. Вы можете продолжить эти запросы с GMT 00:00:00.",
                        success: 'Успех',
                        error: 'Ошибка',

                    }
                }
            },
            tr: {
                translation: {
                    app: {
                        meetingInfo: "Toplantı Bilgileri",
                        title: "Başlık",
                        time: "Zaman",
                        JoinZoomMeeting: "Zoom Toplantısına Katılın",
                        copyAll: "Tümünü Kopyala",
                        participants: "Katılımcılar",
                        selectAll: "Tümünü Seçin",
                        search: "Arama",
                        scheduleMeeting: "Toplantıları Planlayın",
                        meetingTitle: "Toplantı Başlığı",
                        date: "Tarih",
                        duration: "Süre",
                        timeZone: "Zaman Dilimi",
                        attendees: "Katılımcılar",
                        invite: "Davetiye",
                        save: "Kaydet",
                        ok: "Tamam",
                        join: "Katılın",
                        logout: "Oturum Kapatma",
                        settings: "Ayarlar",
                        zoomLogout: "Başarıyla çıkış yaptınız",
                        zoomMeetingLoggedOut: "Zoom Toplantısı Oturumu Kapatıldı",
                        zoomMeetEnd: "Zoom Toplantısı Sona Erdi",
                        zoomMeetEnded: "Zoom Toplantısı başarıyla sonlandırıldı",
                        noMeetStart: "Toplantı başlamadı!",
                        invitationHasBeenSentSuccessfully: "Davet başarıyla gönderildi",
                        youHaveBeenInvitedToJoin: "Katılmak için davet edildiniz",
                        useThisLinkToJoinTheMeeting: "Toplantıya katılmak için bu bağlantıyı kullanın",
                        makeSureToAllowPopups: "açılır pencerelere izin verdiğinizden emin olun",
                        theMeetingSchedulehasbeensetSuccessfully: "Toplantı Takvimi Başarıyla Belirlendi",
                        youNeedToChooseAtLeastOneInvitee: "En az bir davetli seçmeniz gerekir",
                        zoomAuthSuccess: metadata.appName + " Zoom uygulamasının kimliği başarıyla doğrulandı",
                        limitAlertMessage: "Bu belirli kullanıcı için izin verilen Toplantı Oluşturma/Güncelleme API isteklerinin günlük sınırlarını aştınız (100). Bu isteklere GMT 00:00:00'de devam edebilirsiniz.",
                        success: 'Başarı',
                        error: 'Hata',

                    }
                }
            },
            ge: {
                translation: {
                    app: {
                        meetingInfo: "Infos zum Treffen",
                        title: "Titel",
                        time: "Zeit",
                        JoinZoomMeeting: "Zoom Meeting beitreten",
                        copyAll: "Alle kopieren",
                        participants: "Teilnehmer",
                        selectAll: "Alle auswählen",
                        search: "Suchen",
                        scheduleMeeting: "Meetings planen",
                        meetingTitle: "Titel der Sitzung",
                        date: "Datum",
                        duration: "Dauer",
                        timeZone: "ZeitZone",
                        attendees: "Teilnehmer",
                        invite: " Einladen",
                        save: "Speichern",
                        ok: "Ok",
                        join: "Beitreten",
                        logout: "Abmelden",
                        settings: " Einstellungen",
                        zoomLogout: "Sie wurden erfolgreich abgemeldet",
                        zoomMeetingLoggedOut: "Zoom-Meeting abgemeldet",
                        zoomMeetEnd: "Zoom-Meeting beendet",
                        zoomMeetEnded: "Zoom Meeting wurde erfolgreich beendet",
                        noMeetStart: "Kein Meeting gestartet!",
                        invitationHasBeenSentSuccessfully: "Einladung wurde erfolgreich versendet",
                        youHaveBeenInvitedToJoin: "Sie wurden zur Teilnahme eingeladen",
                        useThisLinkToJoinTheMeeting: "Verwenden Sie diesen Link, um dem Meeting beizutreten",
                        makeSureToAllowPopups: "Stellen Sie sicher, dass Sie Popups zulassen",
                        theMeetingSchedulehasbeensetSuccessfully: "Der Besprechungszeitplan wurde erfolgreich erstellt",
                        youNeedToChooseAtLeastOneInvitee: "Sie müssen mindestens einen eingeladenen Teilnehmer auswählen",
                        zoomAuthSuccess: metadata.appName + " Zoom-App erfolgreich authentifiziert",
                        limitAlertMessage: "Sie haben das tägliche Limit (100) der für diesen bestimmten Benutzer zulässigen API-Anfragen für die Erstellung/Aktualisierung von Meetings überschritten. Sie können diese Anfragen um 00:00:00 Uhr GMT wieder aufnehmen.",
                        success: 'Erfolg',
                        error: 'Fehler',

                    }
                }
            }
        }
    })

export default i18next as any;